<script setup>
import {tvTeamParts} from '~/utils/tvDisplay';

// A team's name in a table row: a single name on one line, a pair stacked one
// player per line so neither partner is cut off
const props = defineProps({
  name: {type: String, default: ''},
});

const parts = computed(() => tvTeamParts(props.name));
</script>

<template>
  <span class="tv-team" :class="{'tv-team--pair': parts.length > 1}">
    <span v-for="(part, i) in parts" :key="i" class="tv-team-line">{{ part }}</span>
  </span>
</template>

<style scoped lang="scss">
.tv-team {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  line-height: 1.3;
}

.tv-team-line {
  /* Each line truncates on its own, so each needs room for descenders */
  padding-bottom: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Two lines must fit the row's height */
.tv-team--pair {
  font-size: 0.82em;
  line-height: 1.22;
}
</style>
